
export const environment = {
  production: true,
  apiBaseUrl: "https://api.operazi.com/",
  googleAPIUrl: "https://maps.googleapis.com/maps/api/geocode/json",
  googleAPIKey: "AIzaSyCHRCMw0jsO41118g_TK52mbBB7Ww2kPeE",
  fileURL: "https://api.operazi.com/api/Images/",
  filesURL: "https://api.operazi.com/Files/"

};
